<div class="mat-body-2">
    <mat-card class="news-next">
        <mat-card-title class="top-title">
            <span>Spendenaufruf für Dolly</span>
        </mat-card-title>
        <mat-card-content>
            <div class="donation-block">
                <div class="meter">
                    <app-donation-meter [target]="donationStatus().target" [current]="donationStatus().current"
                        matRipple class="clickable" (click)="openDonationDialog()"></app-donation-meter>
                </div>
                <div class="button">
                    <button mat-flat-button color="primary" (click)="openDonationDialog()">Jetzt spenden</button>
                </div>
            </div>
        </mat-card-content>
        <!-- <mat-card-actions>
            <button mat-flat-button color="primary" (click)="openDonationDialog()">Jetzt spenden</button>
        </mat-card-actions> -->
    </mat-card>
</div>

<!-- <div class="mat-body-2">
    <mat-card class="news-next">
        <mat-card-title class="top-title">
            <span>Spendenaufruf für Dolly</span>
        </mat-card-title>
        <mat-card-content>
            <app-donation-meter [target]="donationStatus().target" [current]="donationStatus().current" matRipple class="clickable" (click)="openDonationDialog()"></app-donation-meter>
        </mat-card-content>
        <mat-card-actions>
            <button mat-flat-button color="primary" (click)="openDonationDialog()">Jetzt spenden</button>
        </mat-card-actions>
    </mat-card>
</div> -->